import { Table as Mui4Table, TableProps as Mui4TableProps } from '@material-ui/core'
import { default as Mui5Table, TableProps as Mui5TablePropsType } from '@mui/material/Table'
import { forwardRef } from 'react'
import { useComponentVersion } from '../hooks'

export enum OsTableVersion {
  V1 = 1, // MUI4
  V2 = 2, // MUI5 + Stratis UI
}
export type TableProps = Mui4TableProps
/** @deprecated Use TableProps */
export type OsTableProps = TableProps

export const Table = forwardRef<HTMLTableElement, TableProps>((props, ref) => {
  const version = useComponentVersion('table')
  switch (version) {
    case OsTableVersion.V2:
      const { padding, ...rest } = props
      let padding5: Mui5TablePropsType['padding'] = padding === 'default' ? 'normal' : padding
      return <Mui5Table ref={ref} padding={padding5} {...rest} />

    default:
      return <Mui4Table ref={ref} {...props} />
  }
})
